import {GES_FINANCIERS} from "@environments/configs/ges-financiers.const";

export const environment = {
  stage: 'stg',
  version: 'v2.0.0',
  production: true,
  bucket: 'cmv-recibos-pagos-pri-stg-use1',
  contactEmailEmma: 'dmartinezb@ucchristus.cl',
  cmvBaseApi: 'https://api.cmv.stg.ucchristus.io',
  uccBaseApi: 'https://apigw.ucchristus.cl/agendaambulatoria-prod',
  gesFinanciers: GES_FINANCIERS.prod,
  cancelAppointmentReasonId: "9957665a-a52f-45e4-8899-a92801359245",
  photos: 'https://assets.ucchristus.cl/fotosProfesionales/prod',
  cognitoUserPool: {
    userPoolId: 'us-east-1_28rzmd630',
    userPoolClientId: '2oikmhk9buenpo5kb6l19bnig8'
  }
};
